import { ICONS } from "../constants";
import { useState, useEffect } from "react";
import "./ShareTransactionContributorRow.css";
import { useTranslation } from "react-i18next";

export default function ShareTransactionContributorRow(props) {
  const { t } = useTranslation();
  const {
    contributor,
    setContributorShareList,
    transaction,
    newTransaction,
    dividedAmount,
    shouldReloadRow,
    resetShare,
    setResetShare,
    editMode
  } = props;
  const [share, setShare] = useState("");
  const shareType = "share";

  useEffect(() => {
    setContributorShareList((prevState) => ({
      ...prevState,
      [contributor.id]: { share: parseInt(share) || 0, amount: 0 },
    }));
  }, [share, setContributorShareList, contributor]);

  useEffect(() => {
    if (newTransaction) {
      setShare("1");
    } else {
      if (transaction.type === shareType && transaction.affectedContributors) {
        setShare(
          `${transaction.affectedContributors[contributor.id]?.share ?? 0}`
        );
      } else {
        setShare("1");
      }
    }
  }, [contributor, transaction, newTransaction, shouldReloadRow]);

  useEffect(() => {
    if (resetShare) {
      setShare("1");
      setResetShare(false);
    }
  },[resetShare,setResetShare]);
  
  //to ensure share will not be negative
  const [iconDisable, setIconDisable] = useState(false);
  useEffect(() => {
    if (share < 0) {
      setShare("0");
      setIconDisable(true);
    } else if (share === "0") {
      setIconDisable(true);
    } else {
      setIconDisable(false);
    }
  }, [share]);

  // keep amount in short(K , M , G).
  const [abbreviatedAmount, setAbbreviatedAmount] = useState(
    `$ ` + dividedAmount
  );
  useEffect(() => {
    function abbreviateThousands(num, digits) {
      const lookup = [
        { value: 1, symbol: "" },
        { value: 1e3, symbol: "k" },
        { value: 1e6, symbol: "M" },
        { value: 1e9, symbol: "B" },
        { value: 1e12, symbol: "T" },
        { value: 1e15, symbol: "P" },
        { value: 1e18, symbol: "E" },
      ];
      const rx = /\.0+$|(\.[0-9]*[1-9])0+$/;
      let item = lookup
        .slice()
        .reverse()
        .find(function (item) {
          return num >= item.value;
        });
      if (num >= 1e21) {
        return "MAX";
      } else {
        return item
          ? (num / item.value).toFixed(digits).replace(rx, "$1") + item.symbol
          : "0";
      }
    }
    setAbbreviatedAmount(`$ ` + abbreviateThousands(dividedAmount, 2));
  }, [dividedAmount]);

  return (
    <div className="d-flex align-items-center">
      <div className="col-6">
        <div className="d-flex align-items-center ms-sm-4">
          <div className="d-inline fs-3 me-1">{ICONS[contributor.icon]}</div>
          <div className="d-inline text-truncate">{contributor.name}</div>
        </div>
      </div>
      <div className="col-6 d-flex justify-content-end">
        <div className="d-flex justify-content-end me-sm-4">
          <div className="">
            <label className="form-label me-2">
              <small>{t("transaction.shares")}</small>
            </label>
            <div className="d-flex">
            {editMode &&
              <button
                className="btn btn-link"
                onClick={() => setShare(`${(parseInt(share) || 0) - 1}`)}
                disabled={!editMode || iconDisable}
              >
                <i className="bi-dash-circle-fill" />
              </button> }
              <input
                type="number"
                className="form-control share-transaction-contributor-row-input text-center"
                value={share}
                onChange={(e) => {
                  setShare(e.target.value);
                }}
                disabled={!editMode}
              />
              {editMode &&
              <button
                className="btn btn-link"
                onClick={() => setShare(`${(parseInt(share) || 0) + 1}`)}
                disabled={!editMode}
              >
                <i className="bi-plus-circle-fill" />
              </button> }
            </div>
            <div className="d-flex justify-content-center mt-2">
              <div className="text-truncate xx-sm">{abbreviatedAmount}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
